// 活动广场路由
export default [
  // 活动广场首页
  {
    path: '/EventPlaza',
    name: 'EventPlaza',
    meta: {
      IndexHeader: true,
      itemIndex: 2
    },
    component: () =>
    import(/* webpackChunkName: "EventPlaza" */ '@/components/event-plaza/index.vue'),
    children: [
      // 广场聚合页面
      {
        path: 'index',
        name: 'EventPlaza_Index',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_EditContent" */ '@/components/event-plaza/index/index')
      },
      // 广场首页
      {
        path: 'home',
        name: 'EventPlaza_home',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_EditContent" */ '@/components/event-plaza/home/index')
      },
      // 编辑投稿页面
      {
        path: 'EditContent',
        name: 'EventPlaza_EditContent',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_EditContent" */ '@/components/event-plaza/edit-content/index')
      },
      // 文章内容页面
      {
        path: 'articleContent',
        name: 'EventPlaza_ArticleContent',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_articleContent" */ '@/components/event-plaza/article-content/index')
      },
      // 视频内容页面
      {
        path: 'videoContent',
        name: 'EventPlaza_VideoContent',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_videoContent" */ '@/components/event-plaza/video-content/index')
      },
      // 预览文章页面
      {
        path: 'previewArticle',
        name: 'EventPlaza_PreviewArticle',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_preview" */ '@/components/event-plaza/preview/previewArticle')
      },
      // 预览视频页面
      {
        path: 'previewVideo',
        name: 'EventPlaza_PreviewVideo',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_preview" */ '@/components/event-plaza/preview/previewVideo')
      },
      // 活动消息和公告列表
      {
        path: 'InfoList',
        name: 'EventPlaza_InfoList',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_InfoList" */ '@/components/event-plaza/info-list/index')
      },
      // 投票列表
      {
        path: 'VoteList',
        name: 'EventPlaza_VoteList',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_InfoList" */ '@/components/event-plaza/vote-list/index')
      },
      // 我的内容列表
      {
        path: 'MineList',
        name: 'EventPlaza_MineList',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_MineList" */ '@/components/event-plaza/mine-list/index')
      },
      // 粉丝和关注页面
      {
        path: 'FansFollow',
        name: 'EventPlaza_FansFollow',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_FansFollow" */ '@/components/event-plaza/fans-follow/index')
      },
      
      // 达人专区
      {
        path: 'TalentShow',
        name: 'EventPlaza_TalentShow',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_TalentShow" */ '@/components/event-plaza/talent-show/index')
      },
      // 话题首页
      {
        path: 'TopicPage',
        name: 'EventPlaza_TopicPage',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_TopicPage" */ '@/components/event-plaza/topic-page/index')
      },
      // 话题首页
      {
        path: 'ContestList',
        name: 'EventPlaza_ContestList',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_ContestList" */ '@/components/event-plaza/contest-list/index')
      },
      // 帖子详情
      {
        path: 'PostDetail',
        name: 'EventPlaza_PostDetail',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_ContestList" */ '@/components/event-plaza/info-list/post-detail')
      },
      // 内容删除页面
      {
        path: 'DeletePage',
        name: 'EventPlaza_DeletePage',
        meta: {
          IndexHeader: true,
          itemIndex: 2
        },
        component: () =>
        import(/* webpackChunkName: "EventPlaza_DeletePage" */ '@/components/event-plaza/delete-page/index')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/event-plaza.js